import Link from "next/link";
import { useRouter } from "next/router";
import { HiOutlineTrash } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { useCart } from "@/contexts/cart/CartContext";
import { DELETE_CART_ITEM } from "@/services/cart";
import { BsCart4 } from "react-icons/bs";
import { event_cart_updated, event_remove_from_cart } from "@/utils/gtm";
import { validateImgSrc } from "@/utils/global";
import NextImage from "../NextImage";
import CurrencyIcon from "../icons/CurrencyIcon";
const CartPopUp = ({ items, t }) => {
  const { dispatch, cart } = useCart();
  const { locale, pathname } = useRouter();
  const total = (items || [])?.reduce(
    (acc, product) =>
      acc +
      (product?.base_price_incl_tax
        ? product?.base_price_incl_tax
        : product.prices_with_tax?.price),
    0
  );

  const handleDeleteItem = (product) => {
    DELETE_CART_ITEM(product?.item_id).then((res) => {
      let theId = product?.item_id;
      if (res.data !== null) {
        dispatch({
          type: "DELETE_ITEM",
          payload: { item_id: theId },
        });
        toast.success(
          locale === "en" ? "Product removed successfully" : "تم المسح بنجاح"
        );
        console.log("remove product from popup", product);
        event_remove_from_cart(
          product?.sku,
          Array.isArray(product?.name) ? product?.name?.at(0) : product?.name,
          product?.qty,
          product?.prices_with_tax?.price,
          product?.option_text_brand?.at(0),
          product?.product_type,
          product?.image,
          product?._category_?.main_category?.category_id,
          product?._category_?.main_category?.name,
          product?._category_?.sub_categories?.at(0)?.category_id,
          product?._category_?.sub_categories?.at(0)?.name
        );

        const items = cart?.cartItems
          .map((item) => ({
            ...item,
            price_incl_tax: item.price || item?.prices_with_tax?.price,
            name: Array.isArray(item.name) ? item.name?.at(0) : item.name,
            categoryname: item?._category_?.main_category?.name,
            subcategoryname: item?._category_?.sub_categories?.at(0)?.name,
          }))
          .filter((i) => i.sku != product?.sku);
        const skus = items?.map((item) => item?.sku)?.join(", ");
        const names = items?.map((item) => item?.name)?.join(", ");
        const subtotal = items?.reduce(
          (a, item) => typeof item.price == "number" && a + item?.price,
          0
        );
        const tax = items?.reduce(
          (a, item) =>
            typeof item.price == "number" &&
            a + (item?.prices_with_tax?.price - item.price),
          0
        );
        const grand_total = items?.reduce(
          (a, item) =>
            typeof item.price == "number" && a + item?.prices_with_tax?.price,
          0
        );
        const cartData = [
          items,
          items?.length,
          skus,
          names,
          Number(subtotal.toFixed(2)),
          Number(tax.toFixed(2)),
          Number(grand_total.toFixed(2)),
        ];
        console.log(cart);
        event_cart_updated(...cartData);
      } else {
        toast.error(
          locale === "en"
            ? "Error: Faild to delete product"
            : "حذث خطأ أثناء مسح المنتج"
        );
      }
    });
  };

  return (
    <div
      className={`hidden group-hover:block duration-500 transition-all absolute w-[300px] ring-1 ring-slate-200 shadow-lg z-50 top-11 ${
        locale === "ar"
          ? "left-1/2 -translate-x-1/2"
          : "right-1/2 translate-x-1/2"
      } bg-white  overflow-hidden rounded-lg`}
    >
      {(items || [])?.length ? (
        <>
          <div className="p-3 pb-0 max-h-[250px] overflow-y-auto red-scrollbar">
            {(items || [])?.map((product, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between pb-2 mb-2 border-b last:pb-0 last:border-b-0 last:mb-0"
              >
                <div className="flex items-center">
                  <NextImage
                    src={validateImgSrc(
                      product?.image
                        ? product.image
                        : `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/catalog/product${product?.extension_attributes?.product_image}`
                    )}
                    className="object-contain w-20 h-20"
                    height={80}
                    width={80}
                    alt="Cart Img !!"
                  />
                  <div className="mx-2">
                    <Link
                      href={`/product/${product?.extension_attributes?.rewrite_url}`}
                      className="mb-1 text-gray-700 line-clamp-1"
                    >
                      {product?.name || ""}
                    </Link>

                    <h3 className="flex items-center gap-1 text-sm font-extrabold text-gray-700">
                      {Math.round(
                        product?.base_price_incl_tax
                          ? product?.base_price_incl_tax || "0"
                          : product?.prices_with_tax?.price || "0"
                      ) || ""}{" "}
                      <CurrencyIcon className="w-3 h-3" />
                    </h3>
                  </div>
                </div>
                <button className="text-red hover:text-lightred">
                  <HiOutlineTrash
                    onClick={() => handleDeleteItem(product)}
                    size={24}
                  />
                </button>
              </div>
            ))}
          </div>
          <div className="sticky bottom-0 p-3 bg-white border-t cursor-pointer">
            <div className="flex items-center justify-between mb-1 text-red">
              <h2 className="font-extrabold">{t("Total")}</h2>
              <h4 className="flex items-center gap-1 font-bold">
                <span>{Math.round(+total || 0) || "0"}</span>{" "}
                <CurrencyIcon className="w-4 h-4" />
              </h4>
            </div>
            <Link
              href="/cart"
              className="block w-full p-2 mb-2 text-center text-white transition-colors duration-300 rounded-md cursor-pointer bg-red hover:bg-lightred"
            >
              {t("Cart")}
            </Link>
            <Link
              href="/checkout"
              className="block w-full p-2 text-center transition-colors duration-300 border rounded-md cursor-pointer border-red text-red hover:text-white hover:bg-red"
            >
              {t("Checkout")}
            </Link>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-4 p-4">
          <BsCart4 size={48} className="text-slate-300" />
          <span>
            {locale === "ar" ? "لا توجد منتجات في السلة" : "No Items in Cart"}
          </span>
          {pathname !== "/" ? (
            <Link
              href="/"
              className="block w-full p-2 mb-2 text-center text-white transition-colors duration-300 rounded-md bg-red hover:bg-lightred"
            >
              {locale === "ar" ? "تسوق من هنا" : "Continue shopping"}
            </Link>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default CartPopUp;
